import _containsNumeric from './containsNumeric.validator'

export const containsNumeric = _containsNumeric
